import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import Form from 'react-bootstrap/lib/Form';
import { toastr } from 'react-redux-toastr';

export class UploadAttachment extends Component {
	constructor(props) {
		super(props);
		this.attachmentDropzone = null;
	}
	render() {
		return (
			<Fragment>
				<Form.Group>
					<div className="field field--input">
						<Form.Label htmlFor="attachmentInput" className="field__label">
							{this.props.label}
						</Form.Label>
						<Form.Control
							id="attachmentInput"
							name="attachmentInput"
							className="field__input"
							disabled={this.props.disabled}
							value={this.props.filename}
							placeholder={this.props.placeholderText}
							onClick={(e) => this.attachmentDropzone.open()}
							readOnly
							tabIndex={-1}
						/>
					</div>
					<Dropzone
						ref={(ref) => (this.attachmentDropzone = ref)}
						style={{}}
						maxSize={this.props.maxSize}
						multiple={false}
						disabled={this.props.disabled}
						onDrop={async (files) => {
							if (files.length === 1) {
								this.props.onUpload(files[0]);
							}
						}}
						onDropRejected={(files) => {
							toastr.info(
								'',
								`Upload pliku nie powiódł się. Najprawdopodobniej przyczyną niepowodzenia był zbyt duży rozmiar pliku. Dopuszczalna wielkość pliku to ${this
									.props.maxSize /
									1024 /
									1024} MB`
							);
						}}
						inputProps={{ ['aria-labelledby']: 'attachmentInput' }}
					/>
				</Form.Group>
			</Fragment>
		);
	}
}

UploadAttachment.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	label: PropTypes.string,
	maxSize: PropTypes.number,
	disabled: PropTypes.bool,
	filename: PropTypes.string,
	placeholderText: PropTypes.string,
	onUpload: PropTypes.func
};
UploadAttachment.defaultProps = {
	id: 'attachment.name',
	name: 'attachment.name',
	label: 'Nazwa załącznika',
	maxSize: 0,
	disabled: false,
	filename: '',
	placeholderText: 'Naciśnij tutaj by dodać załącznik',
	onUpload: Function.prototype
};
